import React from 'react';
import { Row, Card, Col, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import ListInvoices from '../ListInvoices';
import ListSupervisions from '../ListSupervisions';
import { useOwnerContext } from '../../../../../contexts/OwnerContext/OwnerContext';

/**
 * Component for displaying supervision and invoice information cards within a tabbed interface.
 * @component
 * @example
 * const ExampleComponent = () => {
 *   return <SupervisionAndInvoiceInfoCards t={translateFunction} owner={ownerData} />;
 * };
 *
 * @returns {JSX.Element} - The rendered component.
 */
export const SupervisionAndInvoiceInfoCards = () => {
  const { t } = useTranslation();
  const { owner } = useOwnerContext();

  const items = [
    {
      label: t('supervision_and_invoice.tabs.supervisions'),
      key: 'supervisions',
      children: <ListSupervisions owner={owner} />
    },
    {
      label: t('supervision_and_invoice.tabs.invoices'),
      key: 'invoices',
      children: <ListInvoices owner={owner} />
    }
  ];

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} xxl={24}>
        <Card className="card-with-tabs">
          <Tabs defaultActiveKey="supervisions" items={items} />
        </Card>
      </Col>
    </Row>
  );
};
